import Layout from "@/layout";

export default {
  path: "/tableExample",
  component: Layout,
  redirect: "/tableExample/index",
  hidden: true,
  children: [
    {
      path: "index",
      name: "tableExample",
      component: () =>
        import(
          /* webpackChunkName: "tableExample" */ "@/views/common/tableExample"
        ),
    },
  ],
};
